module.exports = __webpack_public_path__ + "img/ceo3.57401f6d.jpg";